export const CURRENT_VIP = {
  date: "4.11.2026",
  time: "18:00",
};
export const CURRENT_INSIDERS = [
  {
    date: "7.11.2026",
  },
  {
    date: "8.11.2026",
  },
];
export const CURRENT_TICKETS = [
  {
    date: "",
  },
  {
    date: "",
  },
];
